import React,{useState,useEffect,useContext} from 'react'
import { BrowserRouter as Router ,Switch,Route,useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap'
import TimePicker from 'react-bootstrap-time-picker';
import PhoneInput from 'react-phone-number-input/input'
import {orderContext} from '../Contexts/OrderProvider'
import {detailContext} from '../Contexts/DetailProvider'
import back from '../assets/arrow.png'
import './forms.css'
const Forms =()=> {
  const history =useHistory();
    const [value, onChange] = useState('');
    const [orders,addOrders] = useContext(orderContext);
    const [state,setState] =useContext(detailContext);
    useEffect(() => {
     var time = 0;
     time=value/3600
     
     var val= 
     timeChange()
    }, [value])
    
    const firstNameChange =(event)=>{
      setState({...state,firstName:event.target.value});
     
      console.log(state);
    }
    const secondNameChange =(event)=>{
        setState({...state,lastName:event.target.value});
        console.log(state);
      }
      const emailChange =(event)=>{
        setState({...state,email:event.target.value});
        console.log(state);
      } 
      const dateChange =(event)=>{
        setState({...state,date:event.target.value});
        console.log(state);
      }
      const timeChange =(val)=>{
        setState({...state,time:val});
        console.log(state);
      }
      const telChange =(event)=>{
        setState({...state,tel:event.target.value});
        console.log(state);
      }
      const numberChange =(event)=>{
        setState({...state,num_of_peoples:parseInt(event.target.value)});
        console.log(state);
      }
     
    const handleSubmit = (e)=>{
      e.preventDefault();
      const elements=document.getElementsByTagName('input');
       const elementArray=Object.values(elements);
       
      elementArray.map((i)=>{
       i.classList.remove('foc')
      });
         if(state.firstName==""){
            const element=document.querySelector('#firstname');
            element.classList.remove('foc');
                 alert("Form contain error");
                 element.classList.add('foc');
            }
            if(state.lastName==""){
              const element=document.querySelector('#lastname');
              element.classList.remove('foc');
              alert("Form contain error");
              element.classList.add('foc');
         }
         if(state.email==""){
          const element=document.querySelector('#exampleInputEmail1');
          element.classList.remove('foc');
               alert("Form contain error");
               element.classList.add('foc');
          }
          if(state.num_of_peoples==""){
            const element=document.querySelector('#num-of-people');
            element.classList.remove('foc');
            alert("Form contain error");
            element.classList.add('foc');
       }
       if(state.date==""){
        const element=document.querySelector('#date');
        element.classList.remove('foc');
        alert("Form contain error");
        element.classList.add('foc');
   }
   if(state.tel==""){
    const element=document.querySelector('#phone');
    element.classList.remove('foc');
    alert("Form contain error");
    element.classList.add('foc');
}
const orderno= Math.floor(100000 + Math.random() * 900000);
setState({...state,order_number:orderno});
const format ={
  method:"GET",
  header:{
    "Content-Type":"application/json"
 },
 body:JSON.stringify(state)
}

history.push('/finalpage');
fetch('/api/reserve',format)
.then((res)=> res.json())
.then((data)=> console.log(data))
.catch((err)=> console.log(err))

}
    return (
     <div>   
         <h1>Complete form</h1>
         <img className="back" src={back} onClick={()=>{history.replace('/Cart');}}></img> 
        <div className="form-border">
    <form onSubmit={handleSubmit}>
     <div class="mb-3">
    <label for="firstname" class="form-label">First Name</label>
    <input type="name" className="form-control" id="firstname" aria-describedby="emailHelp" width="200px" onChange={firstNameChange}></input>
    
  </div>
  <div class="mb-3">
    <label for="lastname" class="form-label">Last Name</label>
    <input type="name" class="form-control" id="lastname" aria-describedby="emailHelp" width="200px" onChange={secondNameChange}></input>
   
  </div>
  <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">E-mail address</label>
    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" width="200px" onChange={emailChange}></input>
    <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
  </div>
  <div class="middle1">
          
      </div>
      <div class="mb-3">
       <div> 
      <label for="phone">Tel:</label>
      </div>
      <div class="tel">
      {/* pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" */}
<input  class="form-control" type="tel" id="phone" name="phone"  onChange={telChange}></input>
   </div>
   <div id="emailHelp" class="form-text">We'll never share your phone-number with anyone else.</div>
  </div>
  <div class="middle1">
          
      </div>  
  <div class="mb-3">
                <div className="row">
                    <div className="" width="30px">
                        <Form.Group class="datep" controlId="dob">
                          <div>
                            <Form.Label>Select Date</Form.Label>
                           </div>
                           <div> 
                            <Form.Control id="date" type="date" name="dob" placeholder="Date of Birth" onChange={dateChange} value={state.date} />
                            </div>
                        </Form.Group>
                    </div>
                </div>
            </div>
    <div class="mb-3">
         <div class="mb">
            <label>Select Time</label>
           </div>    
          <div>
            <TimePicker onChange={onChange} class="timep" start="00:00" end="23:00" step={30} format="hh:ss" value={value} />
        </div>
        </div>          
             <div class="mb-3 last">
    <label for="num-of-people" class="form-label">Number of guests</label>
    <input type="number" class="form-control" id="num-of-people" aria-describedby="emailHelp" width="200px"onChange={numberChange} min="1" max="40"></input>
    
            </div>
      <div class="middle">
          
      </div>       
     <div class="mb-3">
            <div class="last">      
              <button type="submit" class="btn btn-primary" color="black" >Reserve</button>
             </div>
      </div> 
            </form >
            
        </div>
        </div>
    )
}
export default Forms;